var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartToy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5330_3261",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5330_3261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 14C4.43333 14 3.95833 13.8083 3.575 13.425C3.19167 13.0417 3 12.5667 3 12C3 11.4333 3.19167 10.9583 3.575 10.575C3.95833 10.1917 4.43333 10 5 10V7C5 6.73333 5.1 6.5 5.3 6.3C5.5 6.1 5.73333 6 6 6H10C10 5.43333 10.1917 4.95833 10.575 4.575C10.9583 4.19167 11.4333 4 12 4C12.5667 4 13.0417 4.19167 13.425 4.575C13.8083 4.95833 14 5.43333 14 6H18C18.2667 6 18.5 6.1 18.7 6.3C18.9 6.5 19 6.73333 19 7V10C19.5667 10 20.0417 10.1917 20.425 10.575C20.8083 10.9583 21 11.4333 21 12C21 12.5667 20.8083 13.0417 20.425 13.425C20.0417 13.8083 19.5667 14 19 14V19C19 19.2667 18.9 19.5 18.7 19.7C18.5 19.9 18.2667 20 18 20H6C5.73333 20 5.5 19.9 5.3 19.7C5.1 19.5 5 19.2667 5 19V14ZM9 12.5C9.28333 12.5 9.521 12.404 9.713 12.212C9.90433 12.0207 10 11.7833 10 11.5C10 11.2167 9.90433 10.979 9.713 10.787C9.521 10.5957 9.28333 10.5 9 10.5C8.71667 10.5 8.47933 10.5957 8.288 10.787C8.096 10.979 8 11.2167 8 11.5C8 11.7833 8.096 12.0207 8.288 12.212C8.47933 12.404 8.71667 12.5 9 12.5ZM15 12.5C15.2833 12.5 15.521 12.404 15.713 12.212C15.9043 12.0207 16 11.7833 16 11.5C16 11.2167 15.9043 10.979 15.713 10.787C15.521 10.5957 15.2833 10.5 15 10.5C14.7167 10.5 14.4793 10.5957 14.288 10.787C14.096 10.979 14 11.2167 14 11.5C14 11.7833 14.096 12.0207 14.288 12.212C14.4793 12.404 14.7167 12.5 15 12.5ZM8.5 16.5H15.5V15.5H8.5V16.5ZM6 19H18V7H6V19Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartToy);
export default __webpack_public_path__ + "static/media/SmartToy.8d3e4a956ef5f637960fdc045b8885ec.svg";
export { ForwardRef as ReactComponent };